module.exports = __webpack_public_path__ + "img/user-av.c3c71afa.png";